const getColumnCount = table => table.get('columns') ||
    table.get('columnCount') ||
    table.get('columnWidths')?.size;

export default getColumnCount;
